import * as React from 'react';
import { matchPath, withRouter } from 'react-router';
import { getCreatePostBreadcrumb } from './contentManagementBreadcrumbs';

export type Route = {
  path: string;
  title?: string;
  exact?: boolean;
  private?: boolean;
  component?: React.Component | React.ReactNode;
};

type RoutesArray = {
  some?: any;
  routes?: Array<Route>;
};

const renderer = ({
  breadcrumb,
  match,
}: {
  breadcrumb: string | undefined;
  match: any;
}) => {
  if (match.path === '/content-management/:step/create-new') {
    return getCreatePostBreadcrumb(match.params.step);
  }
  return breadcrumb;
};

export const getBreadcrumbs = ({ routes, pathname }: { routes: RoutesArray; pathname: string }) => {
  const matches: Array<Route> = [];
  pathname
    .replace(/\/$/, '')
    .split('/')
    .reduce((previous: string | undefined, current: string) => {
      const pathSection = `${previous}/${current}`;
      let breadcrumbMatch;
      routes.some(({ breadcrumb, path }: { breadcrumb: string | undefined; path: string }) => {
        const match = matchPath(pathSection, { exact: true, path });

        if (match) {
          breadcrumbMatch = {
            breadcrumb: renderer({ breadcrumb, match }),
            path,
            match,
          };
          return true;
        }

        return false;
      });

      if (breadcrumbMatch) {
        matches.push(breadcrumbMatch);
      }

      return pathSection;
    });

  return matches;
};

export const withBreadcrumbs = (routes: RoutesArray) => (Component: any) =>
  withRouter(props => (
    <Component
      {...props}
      breadcrumbs={getBreadcrumbs({
        pathname: props.location.pathname,
        routes,
      })}
    />
  ));



// WEBPACK FOOTER //
// ./src/utils/withBreadcrumbs.tsx